export class WorkspaceClient {
  id: number;
  name: string;
  email: string;
  role: any;
  domains: number[];
  status?: string;
}
